import { useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import Message from '../Message';
import { ChatInputWrapper, MessageInput, Wrapper, MessageThread, Scrollable } from './styled';
import ErrorMessage from '../../../../common/ErrorMessage';
import Button from '../../../../common/Button';
type Props = {
    messages: Message[];
    displayPdfPage: (targetPageNum: number) => void;
    submitMessage: (userInput: string) => Promise<void>;
};
export default function ChatInterfacePanel(props: Props) {
    const { messages, displayPdfPage, submitMessage } = props;
    const [userInput, setUserInput] = useState<string>('');
    const [errorType, setErrorType] = useState<'generic' | 'budget_exceeded' | null>(null);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    async function submit() {
        if (errorType) {
            setErrorType(null);
        }
        try {
            setIsProcessing(true);
            await submitMessage(userInput);
            setUserInput('');
        } catch (error) {
            if (error instanceof Error && error.message === 'budget_exceeded') {
                setErrorType('budget_exceeded');
            } else {
                setErrorType('generic');
            }
        } finally {
            setIsProcessing(false);
        }
    }

    function handleKeyDown(event: React.KeyboardEvent<HTMLTextAreaElement>) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault(); // Prevent newline
            submit();
        }
    }

    function handleOnChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        setUserInput(event.target.value);
    }

    const isFreshThread = messages.length === 0;
    return (
        <Wrapper>
            {!isFreshThread && (
                <Scrollable>
                    <MessageThread>
                        {messages.map((message, index) => {
                            const isLatest = index === messages.length - 1;
                            return (
                                <Message
                                    key={index}
                                    content={message}
                                    isLatest={isLatest}
                                    isLoading={isLatest ? isProcessing : undefined} // we use this only for the latest message
                                    displayPdfPage={displayPdfPage}
                                />
                            );
                        })}
                        {errorType === 'generic' && <ErrorMessage />}
                    </MessageThread>
                </Scrollable>
            )}
            <ChatInputWrapper>
                {errorType === 'budget_exceeded' && (
                    <div style={{ maxWidth: 'var(--max-width)', margin: '0 auto 0.5rem' }}>
                        <ErrorMessage message="Just nu går det inte att använda tjänsten. Vänligen kontakta Verbum om du behöver hjälp." />
                    </div>
                )}
                <MessageInput>
                    <TextareaAutosize
                        value={userInput}
                        onChange={handleOnChange}
                        onKeyDown={handleKeyDown}
                        maxRows={5}
                        placeholder="Vad undrar du om Kyrkoordningen?"
                        disabled={isProcessing}
                        autoFocus
                    />
                    <Button
                        onClick={submit}
                        icon="paperPlane"
                        disabled={isProcessing || !userInput}
                        ghost
                    />
                </MessageInput>
            </ChatInputWrapper>
        </Wrapper>
    );
}
